import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updatePropertyInput } from '../PropertyActions';
import { Form, Card, CardBody, ButtonGroup, Button } from 'reactstrap';
import { InputQuestionCurrency, InputQuestionPercent, InputQuestionText } from '../../../components/Inputs/InputQuestions';

export class PurchaseWizardPage extends Component {

    constructor(props) {
        super(props);
        this.setDepositValue = this.setDepositValue.bind(this)
      }

    setDepositValue(value) {

        const deposit = Math.floor(this.props.values.purchasePrice * value);

        // Fake events! The function expects an event from a html input
        const fakeEvent = {
            target : {
                name : 'deposit',
                value : deposit,
                type : 'text'
            }
        }
        this.props.onChangeHandler(fakeEvent);
    }



    render() {
        const values = this.props.values;

        const dpercent = this.props.values.deposit != 0 ? (this.props.values.deposit/this.props.values.purchasePrice).toFixed(2) : 0;

        return (
            <React.Fragment>
                <h1>Buy to let property tax calculator</h1>
                <h2>Purchase details</h2>
                <Form>
                    <InputQuestionCurrency name="purchasePrice" value={values.purchasePrice} title="Purchase price" onChange={this.props.onChangeHandler} />
                    <InputQuestionCurrency name="deposit" className='no-bottom-margin' value={values.deposit} title="Deposit" onChange={this.props.onChangeHandler} />
                    <ButtonGroup size="sm" className='group-above'>
                        <Button tabindex="-1" color={dpercent == 0.1 ? 'primary' : 'secondary'} onClick={() => this.setDepositValue(0.1)}>10%</Button>
                        <Button tabindex="-1" color={dpercent == 0.2 ? 'primary' : 'secondary'} onClick={() => this.setDepositValue(0.2)}>20%</Button>
                        <Button tabindex="-1" color={dpercent == 0.25 ? 'primary' : 'secondary'} onClick={() => this.setDepositValue(0.25)}>25%</Button>
                        <Button tabindex="-1" color={dpercent == 0.3 ? 'primary' : 'secondary'} onClick={() => this.setDepositValue(0.3)}>30%</Button>
                        <Button tabindex="-1" color={dpercent == 0.35 ? 'primary' : 'secondary'} onClick={() => this.setDepositValue(0.35)}>35%</Button>
                    </ButtonGroup>
                    <InputQuestionCurrency name="otherBuyingFees" value={values.otherBuyingFees} title="Other buying fees" onChange={this.props.onChangeHandler} />
                    <InputQuestionCurrency name="costsRefurbishment" value={values.costsRefurbishment} title="Refurbishment costs" onChange={this.props.onChangeHandler} />
                </Form>
            </React.Fragment>
        );
    }
}





// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/PurchaseWizardPage.jsx